<template>
  <div>
    <LeftSidebarMarkets
      :newVisibleLeft="userInteractions.newVisibleLeft"
      :hoverVariable="userInteractions.hoverVariable"
      :hoverVariableSubItem="userInteractions.hoverVariableSubItem"
      :newSelectedAnalysis="userSelections.newSelectedAnalysis"
      :newSelectedAnalysisParent="userSelections.newSelectedAnalysisParent"
      :itemsInformation="sidebarData.items"
      @onHoverLeftSidebar="onHoverLeftSidebar"
      @onHoverLeftSidebarSubItem="onHoverLeftSidebarSubItem"
      @onLeftSidebarAnalysis="onLeftSidebarAnalysis"
      @eventOnUserClick="onUserClickLeftSidebarShow"
      @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
      @eventOnClientSelect="eventOnClientSelect"
    />
  </div>
</template>

<script>
import LeftSidebarMarkets from "@/components/sideBars/LeftSidebarMarkets.vue";

export default {
  name: "LeftSidebarAdvancedCom",
  components: {
    LeftSidebarMarkets
  },
  props: {
    selectedAnalysis: { required: true, default: "" },
    selectedAnalysisParent: { required: true, default: "" },
    selectedSheet: { required: false, default: 0 },
    visibleLeft: { required: true, type: Boolean, default: false }
  },
  data() {
    return {
      userInteractions: {
        hoverVariable: "",
        hoverVariableSubItem: "",
        newVisibleLeft: false
      },
      sidebarData: {
        items: [
          {
            text: "",
            nameEvent: "",
            bdr: false,
            itemHeader: false,
            classNameIcon: "",
            bdrTransition: false
          }
        ]
      },
      userSelections: {
        newSelectedAnalysis: "",
        newSelectedAnalysisParent: ""
      }
    };
  },
  created() {
    this.setItemsSideBar();
  },
  mounted() {
    this.userSelections.newSelectedAnalysis = this.selectedAnalysis.toString();
    this.userSelections.newSelectedAnalysisParent = this.selectedAnalysisParent.toString();
    Object.assign(this["userInteractions"], {
      newVisibleLeft: this.visibleLeft
    });
  },
  watch: {
    selectedAnalysis: {
      handler(newVal) {
        this.userSelections.newSelectedAnalysis = newVal.toString();
      },
      deep: true
    },
    selectedAnalysisParent(val) {
      this.userSelections.newSelectedAnalysisParent = val.toString();
    },
    visibleLeft(val) {
      Object.assign(this["userInteractions"], {
        newVisibleLeft: val
      });
    },
    "sidebarData.items": {
      handler() {},
      deep: true
    }
  },
  methods: {
    // User interactions
    onHoverLeftSidebar(val) {
      Object.assign(this.userInteractions, { hoverVariable: val });
    },
    onHoverLeftSidebarSubItem(val) {
      this.userInteractions.hoverVariableSubItem = val;
    },
    onUserClickLeftSidebarShow() {
      this.$emit("eventOnUserClickLeftSidebarShow", !this.visibleLeft);
    },
    onLeftSidebarAnalysisScenarios() {
      Object.assign(this.userInteractions, { hoverVariable: "" });
      this.$emit("onLeftSidebarAnalysisScenarios", event);
    },
    onLeftSidebarAnalysis({ val, parent }) {
      this.$emit("eventOnLeftSidebarAnalysis", { val, parent });
    },
    eventOnClientSelect({ item, nameEvent }) {
      this.$emit("eventOnClientSelect", { idx: item.index, nameEvent });
    },
    // Configuration data
    setItemsSideBar() {
      this.$set(this, "sidebarData", {
        items: [
          // {
          //   text: "Scenario Analysis",
          //   nameEvent: "0",
          //   bdr: false,
          //   itemHeader: false,
          //   classNameIcon: "pi pi-align-center fa-rotate-90",
          //   bdrTransition: false,
          //   index: 0
          // },
          {
            text: "Scenario Analysis",
            nameEvent: "2",
            bdr: false,
            itemHeader: false,
            classNameIcon: "pi pi-forward",
            bdrTransition: false,
            index: 2
          },
          {
            text: "Historical Analysis",
            nameEvent: "1",
            bdr: false,
            itemHeader: false,
            classNameIcon: "pi pi-history",
            bdrTransition: false,
            index: 1
          }
        ]
      });
    }
  }
};
</script>
